import {
    CLEAR_ACTION,
    POST_ACTION,
    GET_ACTION,
    PATCH_ACTION,
    DELETE_ACTION, SET_FAIL_MESSAGE
} from "./actionTypes";

const initialState = {
    name: "",
    pilot: 0,
    criticality: 0,
    projectId: "",
    keyResultId:"",
    deadline: "",
    advancement: 0,
    tags:[],
    availableTags: [],
    comment:"",
    message:"",
    status :0,
}

const actionReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ACTION:
            return {
                ...state,
                name: action.payload.name,
                pilot: action.payload.pilot,
                criticality: action.payload.criticality,
                projectId: action.payload.projectId,
                keyResultId: action.payload.keyResultId,
                advancement: action.payload.advancement,
                deadline: action.payload.deadline,
                startDate:action.payload.startDate,
                tags: action.payload.tags,
                availableTags: action.payload.availableTags,
                comment:action.payload.comment,
                message: action.payload.message,
                status: action.payload.status
            };

        case POST_ACTION:
            return {
                ...state,
                name: action.payload.name,
                pilotId: action.payload.pilotId,
                criticality: action.payload.criticality,
                projectId: action.payload.projectId,
                keyResultId: action.payload.keyResultId,
                advancement: action.payload.advancement,
                comment:action.payload.comment,
                deadline: action.payload.deadline,
                message: action.payload.message,
                status: action.payload.status
            };

        case DELETE_ACTION:
            return {
                ...state,
                deleted: action.payload.deleted,
                message: action.payload.message,
                status: action.payload.status
            }
        case PATCH_ACTION:
            return {
                ...state,
                name: action.payload.name,
                pilotId: action.payload.pilotId,
                criticality: action.payload.criticality,
                projectId: action.payload.projectId,
                keyResultId: action.payload.keyResultId,
                advancement: action.payload.advancement,
                comment:action.payload.comment,
                deadline: action.payload.deadline,
                message: action.payload.message,
                status: action.payload.status
            }
        case CLEAR_ACTION:
            return initialState
        case SET_FAIL_MESSAGE :
            return {
                ...state,
                message: action.payload.message,
                status: action.payload.status
            }
        default:
            return {
                ...state
            }
    }
}

export default actionReducer;